import styled, { createGlobalStyle } from "styled-components";

export type TJustifyContent =
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "initial"
    | "inherit";

export type TAlignItems =
    | "stretch"
    | "center"
    | "flex-start"
    | "flex-end"
    | "baseline"
    | "initial"
    | "inherit";

export interface IFlexBoxProps {
    direction?: "row" | "column";
    justify?: TJustifyContent;
    align?: TAlignItems;
    width?: string;
    gap?: string;
    wrap?: "nowrap" | "wrap" | "wrap-reverse" | "initial" | "inherit";
    margin?: string;
    padding?: string;
    textAling?: TAlignItems;
    borderRigth?: string;
    borderLeft?: string;
    height?: string;
    position?: string;
    background?: string

}

export default createGlobalStyle`


 *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    
}

body{
    background-color: ${props => props?.theme?.colors?.background};
    font-size: 14px;
    color: ${props => props?.theme?.colors?.text};
    font-family: sans-serif;
}


`;

export const FlexBox = styled.div<IFlexBoxProps>`
  display: flex;
  justify-content: ${(props) => props?.justify};
  align-items: ${(props) => props?.align};
  flex-direction: ${(props) => props?.direction};
  width: ${(props) => (props?.width ? props?.width : "100%")};
  gap: ${(props) => (props?.gap ? props?.gap : 0)};
  flex-wrap: ${(props) => props.wrap || "nowrap"};
  margin: ${(props) => props?.margin && props?.margin};
  padding: ${(props) => props?.padding && props?.padding};
  text-align: ${(props) => props?.textAling};
  border-right: ${(props) => props?.borderRigth};
  border-left: ${(props) => props?.borderLeft};
  height: ${(props) => props?.height};
  position:  ${(props) => props?.position};
  background-color: ${(props) => props?.background};;
 

`;
